<template>
  <div>
    <div
      class="landing-page-search-content landing-page-search-content_third"
    >
      <selectWithKeyTemplate
        :settings="managementSelectSettings"
        @changeSelect="changeSelectManagement"
      />
    </div>
  </div>
</template>

<script>
import selectWithKeyTemplate from '@/components/fields/selectWithKeyTemplate';

export default {
  name: 'StepThird',
  components: {
    selectWithKeyTemplate,
  },
  props: {
    items: {
      type: Array,
      default: () => '',
    },
    activeManagementForms: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    selectManagementList() {
      const newArr = [];
      this.serviceManagementForms.forEach((item, index) => {
        newArr.push({
          text: item[this.language],
          key: +index,
        });
      });
      return newArr;
    },
    managementSelectSettings() {
      return {
        optionList: this.selectManagementList,
        placeholderText: this.$t('stepsModal.selectlegalForm'),
        selectedKey: this.activeManagementForms,
        disable: false,
        toTop: false,
        tabindex: 1,
        readOnly: true,
        selectClass: 'select_alt',
      };
    },
    language() {
      return this.$i18n.locale;
    },
    serviceManagementForms() {
      return this.items;
    },
  },
  beforeMount() {
    if (this.selectManagementList.length === 1) {
      const activeKey = this.selectManagementList[0].key;
      this.$emit('setActiveManagementForms', +activeKey);
    }
  },
  methods: {
    changeSelectManagement(index) {
      this.$emit('setActiveManagementForms', +index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

.landing-page-search {
  &-content {
    margin: 18px auto 0;

    &__item {
      border: 1px solid $color-gallery;
      border-radius: $borderRadius;
      min-height: 60px;
      padding: 19px 90px;
      color: $color-silver-chalice;
      align-items: center;
      justify-content: center;
      display: inline-flex;
      margin: 0 6px 12px;
      text-align: center;
      cursor: pointer;
      transition: opacity .15s ease-in;
      user-select: none;

      &:hover {
        opacity: .8;
      }

      &_active {
        border-color: $color-dodger-blue;
        color: $color-dodger-blue;
      }
    }

    &__slider {
      cursor: pointer;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 114px;
      height: 114px;

      &_active {
        border: 1px solid $color-dodger-blue;
        border-radius: $borderRadius;
      }

      &-text {
        font: $font-size-sm $font-landing-global;
        color: $color-silver-chalice;
        text-align: center;
        margin-top: 6px;

        &_active {
          color: $color-dodger-blue;
          font: $font-size-base $font-landing-global;
        }
      }
    }
  }

  &-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 65px;

    &_third {
      margin-top: 57px;
    }

    &_disable {
      border-color: $color-silver-chalice;
      pointer-events: none;
      color: rgba($color-white, .4);
    }

    &_margin {
      margin-top: 40px;
    }
  }
}

@include tablet-portrait {
  .landing-page-search {
    &-content {
      display: flex;
      justify-content: center;
    }
  }
}

@include mobile {
  .landing-page-search {
    &-content {
      min-height: auto;
    }
  }
}
</style>
